import { takeLatest, call, put } from 'redux-saga/effects'
import answerLikertCreate, {
  IAnswerLikertCreateRequest,
} from 'api/answers/likerts/Create'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import * as fromActions from '../../../actions/answer-likert.action'

async function createAnswerLikert(data: IAnswerLikertCreateRequest) {
  return await answerLikertCreate(data)
}

function* answerLikertCreateEffectSaga(action: any) {
  try {
    yield call(createAnswerLikert, action.payload)
    yield put(fromActions.Actions.answerLikertCreateSuccess())
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* answerLikertCreateWatcherSaga() {
  yield takeLatest(
    fromActions.ANSWER_LIKERT_CREATE,
    answerLikertCreateEffectSaga
  )
}
